import request from '@/utils/request'
// 登录
export const login = (data) => {
  return request.post('/login', { c: data, method: 'login' })
}
// 查询账户下绑定的金融机构
export const getUserManageFIs = (data) => {
  return request.post('/bank', { c: data, method: 'getUserManageFIs' })
}
// 登录到金融机构
export const loginInFI = (data) => {
  return request.post('/bank', { c: data, method: 'loginInFI' })
}
// 查询合作社列表
export const getSubORGListByFI = (data) => {
  return request.post('/bank', { c: data, method: 'getSubORGListByFI' })
}
// 查询审批列表
export const getExamineListONPCBank = (data) => {
  return request.post('/bank', { c: data, method: 'getExamineListONPCBank' })
}
// 获取下级合作社审核权限列表
export const getExaminePaymentRecordList = (data) => {
  return request.post('/abc', { c: data, method: 'getExaminePaymentRecordList' })
}
// 修改密码
export const editUserPassword = (data) => {
  return request.post('/user', { c: data, method: 'editUserPassword' })
}
export const queryAccountBalance = (data) => {
  return request.post('/abc', { c: data, method: 'queryAccountBalance' })
}